/* import __COLOCATED_TEMPLATE__ from './company-profile-sidebar.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

const SIDEBAR_CLASSNAME = 'company-profile-seller-view__sidebar';

export default class CompanyProfileSidebar extends Component {
  @service media;

  get className() {
    return SIDEBAR_CLASSNAME;
  }
}
